/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Interview_Outcome_AttendedInputs */

const en_admin_user_list_interview_outcome_attended = /** @type {(inputs: Admin_User_List_Interview_Outcome_AttendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attended`)
};

const de_admin_user_list_interview_outcome_attended = /** @type {(inputs: Admin_User_List_Interview_Outcome_AttendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stattgefunden`)
};

/**
* | output |
* | --- |
* | "Attended" |
*
* @param {Admin_User_List_Interview_Outcome_AttendedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_interview_outcome_attended = /** @type {((inputs?: Admin_User_List_Interview_Outcome_AttendedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Interview_Outcome_AttendedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_interview_outcome_attended(inputs)
	return en_admin_user_list_interview_outcome_attended(inputs)
});